import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import coreEN from 'locales/en/core.json';

const resources = {
  en: {
    core: coreEN,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  ns: ['core'],
  defaultNS: 'core',
  interpolation: {
    escapeValue: false, // react already safe from xss
  },
});

export default i18n;
